window.overview = () => {
    return {
        items: [],
        filterColor: true,

        get filteredItems() {
            let filtered = this.items;
            if (this.$store.pt.completed && this.$store.pt.colors.length > 0 && this.filterColor) {
                filtered = filtered.filter(item => item.filter.some(f => this.$store.pt.has(f)));
            }
            return filtered.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]).slice(0, 12);
        },

        switchIntput: {
            ['x-show']() {
                return this.$store.pt.completed;
            }
        }
    };
};
